export default __webpack_public_path__ + "assets/images/06d75e40a265e1ca0de21f763017460d.png";